import tokenRefreshService from "@/services/tokenRefreshService";

export default {
  mixins: [
    require("@mix/notifyToken").default
  ],
  computed: {
    ...mapState(["isLogin", "activeTime", "messageTime", "isDocumentReady"]),
  },
  methods: {
    async onActive() {
      try {
        await this.$store.dispatch("GetRefreshToken");
        this.event_notifyToken();
        this.getData && this.getData();

        // 當 App 從背景回到前景時，檢查並排程下次刷新 Token 時間
        if (this.isLogin) {
          tokenRefreshService.initTokenRefresh();
        }
      } catch (error) {
        // NOTIFICATION("e", `Error in activeTime watch: ${error?.message}` || "系統錯誤");
        console.error('Error in activeTime watch:', error);
      }
    },
    onMessage() {
      this.getData && this.getData();
    },
  },
  watch: {
    activeTime() {
      if (!this.isDocumentReady) return;
      this.onActive();
    },
    messageTime() {
      if (!this.isDocumentReady) return;
      this.onMessage();
    },
  }
};
